/**
 * DevOnly Wrapper Component
 * 
 * This component conditionally renders its children only when debug mode is enabled.
 * It adds visual styling to distinguish dev-only content from regular UI.
 * 
 * Usage:
 * <DevOnly isDebugEnabled={isDebugEnabled}>
 *   <YourTechnicalContent />
 * </DevOnly>
 */

import React from 'react';

export interface DevOnlyProps {
  children: React.ReactNode;
  /**
   * Function to check if debug features should be enabled.
   * Typically checks for ?debug=1 in URL, turbo mode, or non-production environment.
   */
  isDebugEnabled: () => boolean;
}

export const DevOnly: React.FC<DevOnlyProps> = ({ children, isDebugEnabled }) => {
  if (!isDebugEnabled()) {
    return null;
  }

  return (
    <div className="dev-mode-container" style={{
      borderTop: '4px solid #f59e0b',
      marginTop: '2rem',
      padding: '1rem',
      background: '#fffaf0',
      borderRadius: '8px'
    }}>
      <div style={{
        color: '#f59e0b',
        fontFamily: 'monospace',
        fontSize: '0.75rem',
        marginBottom: '0.5rem',
        textTransform: 'uppercase',
        fontWeight: 'bold'
      }}>
        Dev Mode: Engine Rules & Raw Data
      </div>
      {children}
    </div>
  );
};
